export default __webpack_public_path__ + "static/media/play-circle.bc2beca9.svg";